import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import {
  IoArrowBackCircleOutline,
  IoArrowForwardCircleOutline,
  IoClose,
  IoCloseCircleOutline,
  IoCloseOutline,
} from 'react-icons/io5';
import DayBar from './DayBar';
import EmptyDayBar from './EmptyDayBar';

function DatesGraphWithPrice({
  rawPriceData,
  isOpened,
  currency,
  flightTypeCharter,
  onChangeFlightType,
  dateFrom,
  dateTo,
  handleDateChoose,
  handlePriceGraphOpened,
  dropdownRef,
}) {
  const [priceInfo, setPriceInfo] = useState([]);
  const [maxPrice, setMaxPrice] = useState(100000);
  const [minPrice, setMinPrice] = useState(50000);
  const [daysToShift, setDaysToShift] = useState(0);
  const graphContentRef = useRef(null);
  let scrollTimer = useRef(null);
  const barWidth = 26;
  const daysToScroll = 5;

  const getDaysArray = function (start, end) {
    var dateArray = [];
    var currentDate = moment(start);
    var stopDate = moment(end);
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format('DD.MM.YYYY'));
      currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  };

  const fullDayList = getDaysArray(
    moment().format('YYYY-MM-DD'),
    moment().add(4, 'month').format('YYYY-MM-DD')
  );

  useEffect(() => {
    setInitialInfo();
  }, []);

  useEffect(() => {
    setInitialInfo();
  }, [rawPriceData]);

  useEffect(() => {
    let dateOne = moment(moment(dateFrom, 'DD-MM-YYYY'));
    let dateTwo = moment();
    const diff = dateOne.diff(dateTwo, 'days');
    setDaysToShift(diff - daysToScroll);
  }, [isOpened, dateFrom]);

  useEffect(() => {
    graphContentRef.current.scroll(daysToShift * barWidth, 0);
  }, [daysToShift, priceInfo]);

  function setInitialInfo() {
    let pricesArray = [];

    for (let monthKey in rawPriceData) {
      if (rawPriceData[monthKey].days.length > 0) {
        const daysList = rawPriceData[monthKey].days;

        daysList.forEach((day) => {
          if (moment(day.date, 'DD.MM.YYYY').isSameOrAfter()) {
            let dateText = moment(day.date, 'DD.MM.YYYY').format('DD');
            let weekDay = moment(day.date, 'DD.MM.YYYY').format('dd');
            let monthInfo = moment(day.date, 'DD.MM.YYYY').format('MMMM YYYY');
            let price = day.price;
            pricesArray.push({
              dateText,
              price,
              date: day.date,
              weekDay,
              monthInfo,
            });
          }
        });
      }
    }
    setPriceInfo(pricesArray);
    setMaxPrice(Math.max(...pricesArray.map((o) => o.price)));
    setMinPrice(Math.min(...pricesArray.map((o) => o.price)));
  }

  function handleBarChoose(date) {
    handleDateChoose({ datefrom: date, dateto: date });
  }

  function shiftGraphToLeft() {
    if (daysToShift - daysToScroll > 0) {
      setDaysToShift(daysToShift - daysToScroll);
    } else setDaysToShift(0);
  }

  function shiftGraphToRight() {
    if (daysToShift < fullDayList.length - 18) {
      setDaysToShift(daysToShift + daysToScroll);
    } else setDaysToShift(fullDayList.length - 18);
  }

  function handleScroll() {
    if (graphContentRef.current) {
      const { scrollLeft } = graphContentRef.current;
      const shiftAmount = Math.round(scrollLeft / barWidth);
      if (scrollLeft / barWidth - shiftAmount) {
        setDaysToShift(shiftAmount);
      }
    }
  }

  function handleScrollTimeout() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(handleScroll, 200);
  }

  const isForwardButtonDisabled = daysToShift === fullDayList.length - 18;
  const isBackButtonDisabled = daysToShift < 1;

  return (
    <div className="graph" ref={dropdownRef}>
      <div className="graph__header">
        <p className="graph__title">График цен</p>
        <label className="hidecharter">
          <input
            onChange={(e) => {
              onChangeFlightType(e.target.checked);
            }}
            type="checkbox"
            className="hidecharter__checkbox"
            checked={flightTypeCharter}
          />
          Показывать только чартерные рейсы
        </label>
        <button
          className="graph__close-btn"
          onClick={handlePriceGraphOpened}
          title="Закрыть окно"
        >
          <IoCloseCircleOutline />
        </button>
      </div>
      <button
        className={`graph__control-btn graph__control-btn_back${
          isBackButtonDisabled ? ' graph__control-btn_disabled' : ''
        }`}
        onClick={shiftGraphToLeft}
      >
        <IoArrowBackCircleOutline />
      </button>
      <button
        className={`graph__control-btn graph__control-btn_forward${
          isForwardButtonDisabled ? ' graph__control-btn_disabled' : ''
        }`}
        onClick={shiftGraphToRight}
      >
        <IoArrowForwardCircleOutline />
      </button>
      <div
        className="graph__content-container"
        ref={graphContentRef}
        onScroll={handleScrollTimeout}
      >
        <div className="graph__content">
          {priceInfo.length > 0 ? (
            <>
              {fullDayList.map((day) => {
                let foundDay = priceInfo.find((item) => item.date === day);
                if (foundDay) {
                  return (
                    <DayBar
                      key={foundDay.date}
                      dateFrom={dateFrom}
                      dateTo={dateTo}
                      foundDay={foundDay}
                      currency={currency}
                      minPrice={minPrice}
                      maxPrice={maxPrice}
                      handleBarChoose={handleBarChoose}
                    />
                  );
                } else {
                  return (
                    <EmptyDayBar
                      key={`empty-${day}`}
                      dateFrom={dateFrom}
                      dateTo={dateTo}
                      date={day}
                      handleBarChoose={handleBarChoose}
                    />
                  );
                }
              })}
            </>
          ) : (
            <div>Нет данных о стоимости билетов</div>
          )}
        </div>
      </div>
      <div className="graph__control-panel">
        <button
          className="graph__confirm-btn"
          onClick={() => {
            handleBarChoose(dateFrom);
            handlePriceGraphOpened();
          }}
        >
          Выбрать {dateFrom}
        </button>
      </div>
    </div>
  );
}

export default DatesGraphWithPrice;
